<template>
    <div>
        <Breadcrumbs />
        <b-card>
            <b-tabs v-model="tabIndex" card>
                <b-tab :title="$t('title.employees')" @click="tabIndex = 0" lazy>
                    <sap-employee />
                </b-tab>
                <b-tab :title="$t('title.business_partner')" @click="tabIndex = 1" lazy>
                    <business-partner />
                </b-tab>
                <b-tab :title="$t('title.campaign')" @click="tabIndex = 2" lazy>
                    <sap-campaign />
                </b-tab>
                <b-tab :title="$t('title.accounts')" @click="tabIndex = 3" lazy>
                    <sap-account />
                </b-tab>
                <b-tab :title="$t('title.customers')" @click="tabIndex = 4" lazy>
                    <sap-customer />
                </b-tab>
                <b-tab :title="$t('title.partners')" @click="tabIndex = 5" lazy>
                    <sap-partner />
                </b-tab>
                <b-tab :title="$t('title.promotions')" @click="tabIndex = 6" lazy>
                    <sap-promotion />
                </b-tab>
                <b-tab :title="$t('title.products')" @click="tabIndex = 7" lazy>
                    <sap-product />
                </b-tab>
                <b-tab :title="$t('title.businessusers')" @click="tabIndex = 8" lazy>
                    <businessusers />
                </b-tab>
                <b-tab :title="$t('title.contects')" @click="tabIndex = 9" lazy>
                    <sapcontacts />
                </b-tab>

            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import sapEmployee from "./sapEmployee";
import businessPartner from "./businessPartner";
import sapCampaign from "./sapCampaign";
import sapAccount from "./sapAccount";
import sapCustomer from "./sapCustomer";
import sapPartner from "./sapPartner";
import sapPromotion from "./sapPromotion";
import sapProduct from "./sapProduct";
import businessusers from "./businessusers";
import sapcontacts from "./sapcontacts.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
    components: { sapEmployee, businessPartner, sapCampaign, sapAccount, sapCustomer, sapPartner, sapPromotion, sapProduct, businessusers, sapcontacts, Breadcrumbs },
    data() {
        return {
            tabIndex: 0
        };
    },
    created() {
        if (this.$route.query.resource) {
            let resource = this.$route.query.resource.toString();
            if (resource == 'employees') {
                this.tabIndex = 0;
            }
            else if (resource == 'business_partner') {
                this.tabIndex = 1;
            }
            else if (resource == 'campaign') {
                this.tabIndex = 2;
            }
            else if (resource == 'accounts') {
                this.tabIndex = 3;
            }
            else if (resource == 'customers') {
                this.tabIndex = 4;
            }
            else if (resource == 'partners') {
                this.tabIndex = 5;
            }
            else if (resource == 'promotions') {
                this.tabIndex = 6;
            }
            else if (resource == 'products') {
                this.tabIndex = 7;
            }
            else if (resource == 'businessusers') {
                this.tabIndex = 8;
            }
        }
    }
};
</script>
